import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
	selector: 'peps-overwatch-logo',
	imports: [],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './overwatch-logo.component.html',
})
export class OverwatchLogoComponent {
	@Input() sizeSvg: string = '';
}
